/**
 * taskAssignmentServiceModule 任务指派服务
 * 2019-05-13 
 * Qian.qianchen
 */
'use strict';
angular.module('taskAssignmentServiceModule', ['assignmentDetailModule', 'assignmentRejectModule', 'assignmentCreateNewReportModule', 'assignmentLogModule', 'planningCenterRelevanceManuscriptModule'])
    .factory('taskAssignmentService', ["$modal", "$q", "trsHttpService", function($modal, $q, trsHttpService) {
        return {
            /**
             * [initStatus description] 状态下拉选项
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            initStatus: function(type) {
                var options;
                if (type == 0) {
                    options = [{ name: "待审核", value: 1 }, { name: "待接收", value: 2 }, { name: "执行中", value: 3 }, { name: "部分执行", value: 4 }, { name: "已完成", value: 5 }, { name: "部分完成", value: 6 }, { name: "驳回", value: -1 }, { name: "全部状态", value: -2 }];
                } else if (type == 1) {
                    options = [{ name: "待送审", value: 0 }, { name: "待审核", value: 1 }, { name: "待接受", value: 2 }, { name: "执行中", value: 3 }, { name: "已完成", value: 5 }, { name: "驳回", value: -1 }, { name: "全部状态", value: -2 }];
                }
                return options;
            },
            /**
             * [getRights description] 获取任务指派权限
             * @return {[type]} [description]
             */
            getRights: function() {
                let defer = $q.defer();
                let params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperKeysOfNormalModal",
                    Classify: "rwzl",
                    ModalName: "任务指令"
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(data) {
                    let rightsArr = data.map(function(item) {
                        return item.OPERNAME;
                    });
                    defer.resolve(rightsArr);
                });
                return defer.promise;
            },
            /**
             * [assignmentDetail description] 任务详情
             * @param  {[type]} assignmentId [description] 任务id
             * @param  {[type]} platform [description] 平台（所有/我的）
             * @return {[type]}              [description]
             */
            assignmentDetail: function(assignmentId, platform) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/taskAssignment/services/assignmentDetail/assignmentDetail_tpl.html",
                    windowClass: 'assignmentDetail-window',
                    backdrop: false,
                    controller: "assignmentDetailCtrl",
                    resolve: {
                        assignmentId: function() {
                            return assignmentId;
                        },
                        platform: function() {
                            return platform;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            /**
             * [assignmentReject description] 任务驳回
             * @param  {[type]} assignmentId [description]
             * @return {[type]}              [description]
             */
            assignmentReject: function(assignmentId) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/taskAssignment/services/assignmentReject/assignmentReject_tpl.html",
                    windowClass: 'assignmentReject-window',
                    backdrop: false,
                    controller: "assignmentRejectCtrl",
                    resolve: {
                        assignmentId: function() {
                            return assignmentId;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            /**
             * [createNewReport description] 关联选题
             * @param  {[type]} assignmentId [description] 任务id
             * @return {[type]}              [description]
             */
            createNewReport: function(assignmentId) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/taskAssignment/services/createNewReport/createNewReport_tpl.html",
                    windowClass: "assignmentCreateNewReport-window",
                    backdrop: false,
                    controller: "assignmentCreateNewReportCtrl",
                    resolve: {
                        assignmentId: function() {
                            return assignmentId;
                        }
                    }
                });
            },
            /**
             * [assignmentLog description] 任务日志
             * @param  {[type]} assignmentId [description]
             * @return {[type]}              [description]
             */
            assignmentLog: function(assignmentId) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/taskAssignment/services/assignmentLog/assignmentLog_tpl.html",
                    windowClass: 'assignmentLog-window',
                    backdrop: false,
                    controller: "assignmentLogCtrl",
                    resolve: {
                        assignmentId: function() {
                            return assignmentId;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            /**
             * [relevanceManuscript 关联稿件]
             * @param  {[type]} selectedItem [description]
             * @return {[type]}      [description]
             */
            relevanceManuscript: function(selectedItem) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './planningCenter/taskAssignment/services/relevanceManuscript/relevanceManuscript_tpl.html',
                    windowClass: 'planning-center-relevance-manuscript',
                    backdrop: false,
                    controller: 'planningCenterRelevanceManuscriptCtrl',
                    resolve: {
                        selectedItem: function() {
                            return selectedItem;
                        }
                    }
                });
                modalInstance.result.then(function(success) {
                    defer.resolve(success);
                }, function(error) {});
                return defer.promise;
            }
        }
    }]);